import BurgerMenu from '@/components/app/BurgerMenu';
import LayoutWrapperHorizontal from '@/components/component-library/LayoutWrapperHorizontal';
import { classes } from '@/helpers/styling';
import useAppFilter from '@/hooks/layout/useAppFilter';

const BurgerMenuHeader = () => {
  const { appIsFiltered } = useAppFilter();

  return (
    <div
      className={ classes('burger-menu-wrapper-perm', { '--is-filtered': appIsFiltered }) }
      data-nosnippet=''
    >
      <LayoutWrapperHorizontal
        forceMobile
        isRow
      >
        <BurgerMenu />
      </LayoutWrapperHorizontal>
    </div>
  );
};

export default BurgerMenuHeader;